import { ZIndex } from "@/lib/utils/ZIndexEnum";
import {
  ArticleTypesMultiSelectQuery,
  HeadAgreementStatusCode,
  RouteAgreementDetailsStateFragment,
} from "@/gql/graphql";
import { Box, Space, Txt } from "@stenajs-webui/core";
import {
  CardHeader,
  FlatButton,
  Tag,
  stenaAngleDown,
  stenaAngleRight,
  stenaTrash,
} from "@stenajs-webui/elements";
import { SwitchWithLabel } from "@stenajs-webui/forms";
import { cssColor } from "@stenajs-webui/theme";
import * as React from "react";
import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "@/redux/RootReducer";
import { articleFormActions } from "../redux/articles-actions";
import { ArticleItemFormModel } from "../types/ArticlesFormModel";
import { articleFormSelectors } from "../redux/articles-selectors";

interface Props {
  expanded: boolean;
  title: string;
  articleId: string;
  onClickExpand: () => void;
  onClickRemove: () => void;
  removeDisabled: boolean;
  articleType: ArticleTypesMultiSelectQuery["productPrice"]["articleType"]["all"]["0"];
  routeAgreement: RouteAgreementDetailsStateFragment;
}

export const ExpansionPaneHeader: React.FC<Props> = ({
  expanded,
  title,
  articleId,
  onClickRemove,
  onClickExpand,
  removeDisabled,
  articleType,
  routeAgreement,
}) => {
  const article = useSelector((state: StoreState) =>
    articleFormSelectors.getSpecificArticleState(state, articleId)
  );
  const dispatch = useDispatch();
  const showFormulaTag = articleType.needsPricingData;
  const showPriceTag = article.prices.some((p) => p.price || p.percent);
  const showIncludedTag = article.includedInPrice;

  const setFields = useCallback(
    (fields: Partial<ArticleItemFormModel>) => {
      dispatch(articleFormActions.setArticleFields(articleId, fields));
    },
    [dispatch, articleId]
  );

  return (
    <CardHeader
      contentLeft={
        <>
          <FlatButton
            size="large"
            leftIcon={expanded ? stenaAngleDown : stenaAngleRight}
            onClick={onClickExpand}
          />
          <Box width={"50px"}>
            <Txt size="large" color={cssColor("--lhds-color-ui-900")}>
              {title}
            </Txt>
          </Box>
          <Space />

          {showIncludedTag && (
            <Tag size="medium" label="Included in price" variant="success" />
          )}

          {showPriceTag && (
            <Tag size="medium" label="Prices" variant="passive" />
          )}
          {showFormulaTag && (
            <Tag size="medium" label="Formula" variant="passive" />
          )}
        </>
      }
      contentRight={
        <FlatButton
          leftIcon={stenaTrash}
          label={"Remove"}
          onClick={onClickRemove}
          disabled={removeDisabled}
        />
      }
    />
  );
};
